<template>
    <div>
        <div v-show="loading" class="loading-fragment">
            <div class="dataTables_processing panel panel-default">
                {{ t('Processing') }}...
            </div>
        </div>
        <div v-show="!loading">
            <br />
            <button @click="opened = !opened" class="btn btn-default">{{ t('Fullscreen') }}</button>

            <hr />

            <default-chart :labels="labels" :items="items" :height="75" :options="chartOptions.default"></default-chart>

            <div class="fullscreen-chart" v-bind:class="{'opened': opened}">

                <br />

                <div class="panel">

                    <table class="table">
                        <tr>
                            <td style="width:50%;">
                                <datepicker v-model="date" @change="onInput" @initialized="onInput" style="float:right"></datepicker>
                            </td>
                            <td>
                                <button @click="opened = !opened" class="btn btn-default">{{ t('Hide') }}</button>
                            </td>
                        </tr>
                    </table>

                    <br />

                    <default-chart :labels="labels" :items="items" :height="135" :options="chartOptions.fullscreen"></default-chart>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import DefaultChart from '../DefaultChart';
    import Datepicker from '../Datepicker.vue';

    export default
    {
        components: {DefaultChart, Datepicker},
        data()
        {
            return {
                date: null,
                opened: false,
                loading: false,
                labels: [],
                items: [],
                chartOptions: {
                    default: {
                        responsive: true,
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false
                                    }
                                }
                            ]
                        }
                    },
                    fullscreen: {
                        responsive: true,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false,
                                    }
                                }
                            ]
                        }
                    }
                }
            };
        },
        mounted()
        {
            if (this.$data.last_import_day) {
                this.date = this.$data.last_import_day;
            }
        },
        methods:
            {
                load()
                {
                    const v = this;

                    this.loading = true;

                    let data = {
                        date: this.date,
                    };

                    this.$http.get('reports/pricehistory/'+this.$data.id, {params: data}).then(response => {
                        this.loading = false;
                        this.labels = response.body.labels;
                        this.items = response.body.items;
                    }, response => {
                        this.loading = false;
                    });
                },
                onInput(value) {
                    this.load();
                }
            }
    }
</script>

<style>
    @keyframes lds-rolling {
        0% {
            -webkit-transform: translate(-50%, -50%) rotate(0deg);
            transform: translate(-50%, -50%) rotate(0deg);
        }
        100% {
            -webkit-transform: translate(-50%, -50%) rotate(360deg);
            transform: translate(-50%, -50%) rotate(360deg);
        }
    }
    @-webkit-keyframes lds-rolling {
        0% {
            -webkit-transform: translate(-50%, -50%) rotate(0deg);
            transform: translate(-50%, -50%) rotate(0deg);
        }
        100% {
            -webkit-transform: translate(-50%, -50%) rotate(360deg);
            transform: translate(-50%, -50%) rotate(360deg);
        }
    }
    .lds-rolling {
        position: relative;
    }
    .lds-rolling div,
    .lds-rolling div:after {
        position: absolute;
        width: 160px;
        height: 160px;
        border: 20px solid #fc4309;
        border-top-color: transparent;
        border-radius: 50%;
    }
    .lds-rolling div {
        -webkit-animation: lds-rolling 0.8s linear infinite;
        animation: lds-rolling 0.8s linear infinite;
        top: 100px;
        left: 100px;
    }
    .lds-rolling div:after {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
    .lds-rolling {
        width: 25px !important;
        height: 25px !important;
        -webkit-transform: translate(-12.5px, -12.5px) scale(0.125) translate(12.5px, 12.5px);
        transform: translate(-12.5px, -12.5px) scale(0.125) translate(12.5px, 12.5px);
    }
</style>


// WEBPACK FOOTER //
// PriceHistory.vue?94c103d0